import { z } from 'zod';
/** Lege strings uit forms/JSON → undefined (voorkomt Zod 500 op ""). */
function emptyToUndefined(val) {
    if (typeof val === 'string' && val.trim() === '')
        return undefined;
    return val;
}
export const loginBodySchema = z.object({
    email: z.string().email(),
    password: z.string().min(8).max(256),
    totp: z.preprocess(emptyToUndefined, z
        .string()
        .regex(/^\d{6}$/)
        .optional()),
    recoveryCode: z.preprocess(emptyToUndefined, z.string().min(8).max(64).optional()),
});
export const totpVerifySchema = z.object({
    token: z.string().regex(/^\d{6}$/),
});
//# sourceMappingURL=auth.js.map